console.log("Tabletop Goodies - Script - Strings");

TTG = function (parent) {

    const result = {};

    const _defaultTrimCharacters = [' ', '\t', '\n', '\r', String.fromCharCode(160)];

    const _isTrimableChar = function (char, characters) {
        for (let j = 0; j < characters.length; j++) {
            if (characters[j] == char) {
                return false;
            }
        }
        return true;
    }

    const _trimEnd = function (value, characters) {
        if (value === null || value === undefined || !TTG.isString(value)) {
            return null;
        }
        if (characters === null || characters === undefined || !Array.isArray(characters)) {
            characters = _defaultTrimCharacters
        }
        let endIndex = value.length;
        for (let i = value.length - 1; i > -1; i--) {
            if (_isTrimableChar(value.charAt(i), characters)) {
                endIndex = i;
                break;
            }
        }
        if (endIndex > value.length - 1) {
            return "";
        }
        else {
            return value.substring(0, endIndex + 1);
        }
    }

    const _trimStart = function (value, characters) {
        if (value === null || value === undefined || !TTG.isString(value)) {
            return null;
        }
        if (characters === null || characters === undefined || !Array.isArray(characters)) {
            characters = _defaultTrimCharacters
        }
        let startIndex = -1;
        for (let i = 0; i < value.length; i++) {
            if (_isTrimableChar(value.charAt(i), characters)) {
                startIndex = i;
                break;
            }
        }
        if (startIndex === -1) {
            return "";
        }
        else {
            return value.substring(startIndex);
        }
    }

    const _trim = function (value, characters) {
        if (value === null || value === undefined || !TTG.isString(value)) {
            return null;
        }
        if (characters === null || characters === undefined || !Array.isArray(characters)) {
            characters = _defaultTrimCharacters
        }
        const trimStart = TTG.Strings.trimStart(value, characters);
        const trimEnd = TTG.Strings.trimEnd(trimStart, characters);
        return trimEnd;
    }

    const _isEmptyOrWhiteSpaces = function (value) {
        if (value === null || value === undefined) return true;
        if (value === '') return true;
        if ($ && value instanceof $) {
            return value.length === 0;
        }
        if (typeof (value) === 'string') {
            const trimvalue = _trim(value);
            return trimvalue === '';
        }
        return false;
    };

    const _generatedIdPossibleFirstCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const _generatedIdPossibleCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const _generateRandomString = function (length) {
        if (_isEmptyOrWhiteSpaces(length) || length < 1) length = 20;
        let text = _generatedIdPossibleFirstCharacters.charAt(Math.floor(Math.random() * _generatedIdPossibleFirstCharacters.length));
        for (var i = 1; i < length; i++) {
            text += _generatedIdPossibleCharacters.charAt(Math.floor(Math.random() * _generatedIdPossibleCharacters.length));
        }
        return text;
    };

    if (window.performance.now) {
        result.getTimestamp = function () { return window.performance.now(); };
    } else {
        if (window.performance.webkitNow) {
            result.getTimestamp = function () { return window.performance.webkitNow(); };
        } else {
            result.getTimestamp = function () { return new Date().getTime(); };
        }
    }

    result.isEmptyOrWhiteSpaces = _isEmptyOrWhiteSpaces;
    result.trim = _trim;
    result.trimEnd = _trimEnd;
    result.trimStart = _trimStart;
    result.generateRandomString = _generateRandomString;

    parent.Strings = result;
    return parent;
}(TTG);

if (!String.prototype.caseInsensitiveEquals) {
    String.prototype.caseInsensitiveEquals = function (value) {
        if (TTG.isNullOrEmpty(this) && TTG.isNullOrEmpty(value)) {
            return true;
        }
        else if (TTG.isNullOrEmpty(this) || TTG.isNullOrEmpty(value)) {
            return false;
        }
        else {
            return this.toUpperCase() === value.toUpperCase()
        }
    }
}

String.prototype.trim = function (characters = null) {
    return TTG.Strings.trim(this, characters);
};

String.prototype.trimStart = function (characters = null) {
    return TTG.Strings.trimStart(this, characters);
};

String.prototype.trimEnd = function (characters = null) {
    return TTG.Strings.trimEnd(this, characters);
};


if (!String.prototype.toUpperCaseFirstLetter) {
    String.prototype.toUpperCaseFirstLetter = function () {
        if (TTG.isNullOrEmpty(this)) {
            return this;
        }
        else {
            return this.charAt(0).toUpperCase() + this.slice(1);
        }
    };
}

